<template>
    <div class="page blog-page">
        <div class="card">
            <div class="card-content">
                <div class="post-title">The filter(Boolean) trick</div>
                <div class="post-content">
                    <p>Here's a trick I stumbled upon.</p>
                    <p>
                        Say you have an array of strings:<br />
                        <code>
                            const names = ['Neymar', 'Messi', 'Ronaldo']
                        </code>
                    </p>
                    <p>
                        And you want to display it as a comma separated string:
                        <br />
                        <code>Neymar, Messi, Ronaldo</code>
                    </p>

                    <p>
                        But hiding in that array are some undesired empty values
                        such as
                        <code>''</code>, <code>null</code>, or
                        <code>undefined</code>.
                    </p>
                    <p>
                        No problema, just filter out falsy values. Right?
                    </p>
                    <p>
                        Old me:
                        <code>
                            names.filter(name => !!name).join(', ')
                        </code>
                    </p>
                    <p>
                        New me:
                        <code>
                            names.filter(Boolean).join(', ')
                        </code>
                    </p>
                    <p>Cheers!</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <div class="post-title">
                    How to make Git ignore file mode (chmod) changes
                </div>
                <div class="post-content">
                    <p>
                        After changing some file permissions on my EC2 instance
                        I noticed that <code>git status</code> was showing
                        unstaged changes on those files.
                    </p>
                    <p>
                        Wondering what the deal was, I did a
                        <code>git diff</code> only to realize the only change
                        was the new permission.
                    </p>
                    <p>
                        A quick Google search revealed how Git tracks changes in
                        file permissions and how this could be turned off by
                        running the following from within the repo:
                    </p>
                    <code>git config core.fileMode false</code>
                    <p>Cheers!</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <div class="post-title">
                    Getting Go button in iOS keyboard for HTML inputs
                </div>
                <div class="post-content">
                    <p>
                        While testing a personal site on iOS, I noticed the iOS
                        keyboard was showing <strong>Return</strong> instead of
                        the desired <strong>Go</strong> button for forms on
                        input text focus.
                    </p>
                    <p>
                        I thought that was kind of odd and proceeded to double
                        check the markup to make sure nothing was awry.
                    </p>
                    <p>
                        After a good hard look and bit of head scratching it
                        finally dawned on me that I had left out the
                        <strong>action</strong> attribute thinking it wouldn't
                        be necessary because afterall it was an AJAX form.
                    </p>
                    <p>
                        While you are not required to specify an action
                        attribute in such case I personally feel it's a good
                        practice for a better mobile experience.
                    </p>
                    <code>
                        &lt;form action="#"&gt;
                    </code>
                    <p>Cheers!</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <div class="post-title">
                    Running Node apps in Production
                </div>
                <div class="post-content">
                    <p>
                        Here's a great
                        <a
                            target="_blank"
                            href="https://expressjs.com/en/advanced/pm.html"
                        >
                            guide
                        </a>
                        on process managers and how to serve your Node apps in
                        production.
                    </p>
                    <p>Cheers!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Blog',
}
</script>
